import {Col, ColType, Crud} from "../../comp/crud";
import {ApiClient, Menu} from "../../api/ApiClient";
import {useContext} from "react";
import {SiteInfoContext} from "../context/SiteInfoContext";

let apiClient = ApiClient.getDefault();

export default function Role(){
    const siteInfo = useContext(SiteInfoContext)

    let cols: Col[] = [
        {
            name: "ID",
            key: "id",
            width: 60,
            hideInEdit: true,
            type: ColType.STRING
        },
        {
            name: "名称",
            key: "name",
            width: 120,
            type: ColType.STRING
        },
        {
            name: "Code",
            key: "code",
            width: 140,
            type: ColType.STRING
        },
        {
            name: "菜单",
            key: "ext.menus",
            render: (value, index) => {
                if(!siteInfo){
                    return value
                }
                let menus: Menu[] = []
                siteInfo.menus.forEach(m => {
                    menus = menus.concat(m.menus)
                })
                return value.map((v: any) => {
                    let menu = menus.filter(m => m.code == v)[0]
                    if(!menu){
                        return '';
                    }
                    return menu.name || v
                }).join(", ")

            },
            type: ColType.MULTI_SELECT,
            getOptions: async (row) => {
                if(!siteInfo){
                    return []
                }
                let menus: Menu[] = []
                siteInfo.menus.forEach(m => {
                    menus = menus.concat(m.menus)
                })
                return menus.map(m => {
                    return  {
                        label: m.name,
                        value: m.code,
                        key: m.code
                    }
                })
            }
        },
    ]
    return <Crud
        canUpdate={true}
        canCreate={true}
        name="角色管理"
        entityKey="roles"
        pageSize={50}
        cols={cols}
    />
}